// extracted by mini-css-extract-plugin
module.exports = {"approvalContainer":"AddApprovalContainer_approvalContainer__1Q8hN","title":"AddApprovalContainer_title__3_mGu"};